<template>
  <div class="main">
    <report-top> </report-top>
    <div id="formTable">
      <div class="lyleft">
        <start-end ref="startEnd" timeModel="2,3"></start-end>
        <Button @click="chaxun" type="primary" size="small" class="chaxun"
          >立即查询</Button
        >
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="beforepic">
        <viewer
          v-if="row.beforeImgList != null && row.beforeImgList.length > 0"
        >
          <img
            v-for="(x, index) in row.beforeImgList"
            :key="index"
            :src="axios.platConfig.fileUri + x"
            width="24"
            height="24"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
      </template>
      <template slot-scope="{ row, index }" slot="pic">
        <viewer v-if="row.afterImgList != null && row.afterImgList.length > 0">
          <img
            v-for="(x, index) in row.afterImgList"
            :key="index"
            :src="axios.platConfig.fileUri + x"
            width="24"
            height="24"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="chuli(row, index)">处理</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="openForm"
      title="事件处理"
      footer-hide
      width="400"
      height="400"
      @on-cancel="cliclCancelBtn"
    >
      <Form ref="item" :model="item" :rules="ruleValidate" :label-width="80">
        <Row :gutter="16">
          <Col span="24">
            <FormItem label="工作反馈" prop="feedBack">
              <Input v-model="item.feedBack" placeholder="请输入"></Input>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="处理图片" prop="afterImgList">
              <ly-photo ref="lyphoto" v-model="item.afterImgList"></ly-photo>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Col span="24">
            <div class="btn-wrap">
              <Button @click="resetForm">重置表单</Button>
              <Button type="primary" @click="process('item')">立即处理</Button>
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>

  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openForm: false,
      isAdd: false,
      axios:axios,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "事件编码",
          key: "no",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "项目名称",
          key: "groupName",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "地址",
          key: "address",
          minWidth: 300,
          maxWidth: 350,
        },
        {
          title: "事件内容",
          key: "content",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "事件来源",
          key: "source",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "业务事件",
          key: "businessType",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "上报图片",
          slot: "beforepic",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "处理图片",
          slot: "pic",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "预计完成时间",
          minWidth: 130,
          maxWidth: 200,
          render: (h, data) => {
            return h("div", this.utils.time(data.row.finishTime, "yymmddhhmm"));
          },
        },
        {
          title: "实际完成时间",
          minWidth: 130,
          maxWidth: 200,
          render: (h, data) => {
            return h(
              "div",
              this.utils.time(data.row.realFinishTime, "yymmddhhmm")
            );
          },
        },
        {
          title: "创建者账号",
          key: "createAccount",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "当前状态",
          key: "eventStatus",
          render: (h, data) => {
            return h("div", this.$t("eventStatus." + data.row.status));
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "操作",
          slot: "action",
          width: 150,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        feedBack: "",
        afterImgList: [],
      },
      ruleValidate: {
        name: { required: true, message: "必填" },
        icon: { required: true, message: "必填" },
      },
      pageNumber: 1,
      pageSize: 50,
      total: 0,
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.event + "/event/recheckList",
        data: {
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          groupId: "",
          businessType: "",
          source: "",
          keyWork: "",
          startTime: this.timeObj.start,
          endTime: this.timeObj.end,
          no: "",
        },
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.tableData = data;
      });
    },
     //点击编辑按钮
    chuli(v) {
      this.item.id = v.id;
      this.openForm = true;
    },
    process() {
      this.utils.loading(this, "加载中");
      console.log(this.item);
      axios({
        method: "post",
        url: axios.event + "/event/process",
        data: this.item,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.openForm = false;
          this.getList();
        }
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.openForm = true;
      this.isAdd = false;
      this.item = row;
    },
    openAdd() {
      this.openForm = true;
      this.isAdd = true;
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    cliclCancelBtn() {
      this.openForm = false;
      var arr = this.tableData;
      this.tableData = [];
      setTimeout(() => {
        this.tableData = arr;
      }, 200);
    },
    changePage(x) {
      this.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.pageSize = x;
      this.getList();
    },
    chaxun() {
      this.timeObj = this.$refs.startEnd.getTimeObj();
      this.getList();
    },
  },
  mounted() {
    this.chaxun();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/event/eventRecheck.vue